/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Latest_Reply_ColInputs */

const en_settings_tickets_latest_reply_col = /** @type {(inputs: Settings_Tickets_Latest_Reply_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Reply`)
};

/**
* | output |
* | --- |
* | "Latest Reply" |
*
* @param {Settings_Tickets_Latest_Reply_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_latest_reply_col = /** @type {((inputs?: Settings_Tickets_Latest_Reply_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Latest_Reply_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_latest_reply_col(inputs)
});
export { settings_tickets_latest_reply_col as "settings.tickets.latest_reply_col" }